import { c as _c } from "react/compiler-runtime";
import { useBannerDismiss, type BannerId, BANNER_IDS } from 'shared/hooks/useBannerDismiss';
import { useHasClientFeatureAccess } from 'shared/hooks/useHasFeatureAccess';
import { useCurrentClient } from 'shared/context/ClientContext';
import { useQueryConnectorConfigs } from 'src/connectors/api';
import { ConnectorPlatformTypes } from 'src/connectors/types';

/**
 * This hook determines whether to display the banner for in-app marketing (Alvie native pinterest connector)
 * based on user dismissal state, feature availability, and whether the client already has a Pinterest connector.
 * @returns object with shouldShow flag, isLoading flag, dismiss function, and snooze function
 */
export const usePinterestBanner = () => {
  const $ = _c(15);
  const {
    currentClient
  } = useCurrentClient();
  const {
    checkClientAccessToFeature
  } = useHasClientFeatureAccess();
  const {
    id: bannerId,
    shouldShow: isNotDismissed,
    dismiss: dismissBanner,
    isLoading: isDismissalLoading
  } = useBannerDismiss(BANNER_IDS.nativePinterestConnector);
  const {
    data: t0,
    isLoading: isLoadingConfigs
  } = useQueryConnectorConfigs(currentClient.id);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const connectorConfigs = t1;
  let t2;
  if ($[2] !== connectorConfigs) {
    t2 = connectorConfigs.some(_temp);
    $[2] = connectorConfigs;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hasPinterestConnector = t2;
  const isLoading = isDismissalLoading || isLoadingConfigs;
  let t3;
  if ($[4] !== checkClientAccessToFeature || $[5] !== hasPinterestConnector || $[6] !== isNotDismissed) {
    t3 = isNotDismissed && !hasPinterestConnector && checkClientAccessToFeature({
      featureId: "connectors"
    })?.hasAccess === true;
    $[4] = checkClientAccessToFeature;
    $[5] = hasPinterestConnector;
    $[6] = isNotDismissed;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const shouldShow = t3;
  let t4;
  if ($[8] !== dismissBanner) {
    t4 = () => {
      dismissBanner({
        days: 90,
        scope: "client"
      });
    };
    $[8] = dismissBanner;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const dismiss = t4;
  let t5;
  if ($[10] !== bannerId || $[11] !== dismiss || $[12] !== isLoading || $[13] !== shouldShow) {
    t5 = {
      bannerId,
      shouldShow,
      isLoading,
      dismiss
    };
    $[10] = bannerId;
    $[11] = dismiss;
    $[12] = isLoading;
    $[13] = shouldShow;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
function _temp(config) {
  return config.service === ConnectorPlatformTypes.PINTEREST;
}